import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  AppBar,
  Toolbar,
  DialogActions,
} from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import BackWithArrow from "../../common/BackWithArrow";
import LogsIconDesign from "../../common/LogsIconDesign";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function NewCalibrationLogButton() {
  const [open, setOpen] = useState(false);

  const dummyData = [
    {
      id: 1,
      userName: "John Doe",
      addedTime: "2023-10-01 10:00 AM",
      details: "Calibration for EQ1",
    },
    {
      id: 2,
      userName: "Jane Smith",
      addedTime: "2023-10-02 02:30 PM",
      details: "Calibration for EQ2",
    },
    {
      id: 3,
      userName: "Alice Johnson",
      addedTime: "2023-10-03 11:15 AM",
      details: "Calibration for EQ3",
    },
  ];

  return (
    <>
      <LogsIconDesign
        variant="outlined"
        startIcon={<Add />}
        onClick={() => setOpen(true)}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen
      >
        <BackWithArrow onBack={() => setOpen(false)} />

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>ID</strong>
                    </TableCell>
                    <TableCell>
                      <strong>User Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Added Time</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Details</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dummyData.map((log) => (
                    <TableRow key={log.id}>
                      <TableCell>{log.id}</TableCell>
                      <TableCell>{log.userName}</TableCell>
                      <TableCell>{log.addedTime}</TableCell>
                      <TableCell>{log.details}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#4F46E5",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#FFFFFF",
                color: "#4F46E5",
              },
            }}
            startIcon={<RestartAltIcon color="#4F46E5" />}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
